/* The sentence beside a refused field (Q-06). Tokens only (ADR-0007). It sits inside the form's own
   `label`, directly under the control, so it reads as that field's and not the form's. */
.error {
  display: block;
  margin: 0;
  font-size: var(--t-min);
  font-weight: 500;
  line-height: 1.45;
  color: var(--crit);
}

/* Any control a form marked refused gets the critical border, whatever the form's own input class
   is called: the attribute is the contract (`FieldProps`), the colour is the second signal. */
[data-field][aria-invalid="true"] {
  border-color: var(--crit);
}
